export enum HomeRoutePathsEnum {
  HOME = '/',
}
